module.exports = __webpack_public_path__ + "img/straight-rail-vertical-ties.1274fc87.png";